module.exports = {"months":["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"period":{"am":"am","pm":"pm"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Timestamp/copy/en.json
// module id = 837
// module chunks = 0